import './Container.css';

import React, { useEffect, useRef, useState } from 'react';

interface ContainerProps {
  className?: string;
  overflowY?: boolean,
  scrollBottom?: boolean,
  scrollCondition?: any
}

const Container: React.FC<ContainerProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  const [latestScrollCondition, setLatestScrollCondition] = useState(null as any);

  const classNames = ["container"];

  if (props.className !== undefined) classNames.push(props.className);
  if (props.overflowY !== undefined) classNames.push("container-sy");

  useEffect(() => {
    if (props.scrollBottom) {
      if (latestScrollCondition != props.scrollCondition) {
        setLatestScrollCondition(props.scrollCondition);

        for (let i = 0; i < classNames.length; i++) {
          if (classNames[i] == "scrolled") {
            classNames.splice(i, 1);
          }
        }

        scrollToEnd();
      }
    }
  }, [props.scrollCondition])

  const scrollToEnd = () => {
    if (classNames.indexOf("scrolled") < 0) {
      classNames.push("scrolled");

      let scrollInterval = setInterval(function () {
        const currentScroll = Math.ceil(ref.current?.scrollTop!) + ref.current?.clientHeight!;
        const maxScroll = ref.current?.scrollHeight!;

        if (currentScroll < maxScroll) {
          ref.current?.scrollTo(0, maxScroll);
        } else {
          clearInterval(scrollInterval);
        }
      }, 50);
    }
  }

  return <div className={classNames.join(" ").toString()} ref={ref}>
    {props.children}
  </div>
}

export default Container;



// import { useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
// import React, { useEffect, useRef, useState } from 'react';
// import './Container.css'

// interface ContainerProps {
//   className?: string;
//   overflowY?: boolean,
//   scrollBottom?: boolean
// }

// const Container: React.FC<ContainerProps> = (props) => {
//   const ref = useRef<HTMLDivElement>(null);

//   let [classNames, setClassNames] = useState(["container"]);

//   useEffect(() => {
//     const classes = [...classNames]
//     if (props.className !== undefined) classes.push(props.className);
//     if (props.overflowY !== undefined) classes.push("container-sy");
//     if (props.scrollBottom !== undefined && props.scrollBottom) classes.push("hidden");
//     setClassNames(classes);

//     if (props.scrollBottom) {
//       let scrollInterval = setInterval(function () {
//         if (ref.current?.scrollTop == 0) {
//           ref.current?.scrollTo(0, ref.current?.scrollHeight);
//         } else {
//           clearInterval(scrollInterval);

//           for (let i = 0; i < classes.length; i++) {
//             if (classes[i] == "hidden") {
//               classes.splice(i, 1);
//             }
//           }

//           setClassNames(classes);
//         }
//       }, 10);
//     }
//   }, [])

//   return <div className={classNames.join(" ").toString()} ref={ref}>
//     {props.children}
//   </div>
// }

// export default Container;
